import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { TODO } from '@/types'

const emptySummaryOfOurStory = (): TODO => ({
  whatsBehindUs: null,
  ourSuccesses: null
})

export const useSummaryOfOurStoryStore = defineStore('summaryOfOurStory', () => {
  const summaryOfOurStory = ref(emptySummaryOfOurStory())

  const clearSummaryOfOurStory = () => {
    summaryOfOurStory.value = emptySummaryOfOurStory()
  }

  const setSummaryOfOurStory = (fields: TODO) => {
    if (!fields) return
    summaryOfOurStory.value = {
      ...summaryOfOurStory.value,
      ...fields
    }
  }

  return {
    summaryOfOurStory,
    clearSummaryOfOurStory,
    setSummaryOfOurStory
  }
})
